import type { ParsedInsightsFilters } from '@/lib/api/types/insights/filters';
import { buildInsightsApiFilter } from '@/lib/utils/insights/buildInsightsApiFilter';
import { tempoApi } from '../tempoApi';
import type {
  ItemHealthByItemIdsRequest,
  ItemHealthByItemIdsResponse,
  ItemsHealthMetrics,
} from '../types/insights/health';
import { INSIGHTS_API_BASE, INSIGHTS_TIMEOUT_MS } from './constants';

const getHealthSummary = async ({
  filters,
  scopeItemId,
  loopId,
}: {
  filters: ParsedInsightsFilters;
  scopeItemId?: number;
  loopId: number;
}): Promise<ItemsHealthMetrics> => {
  const filterString = buildInsightsApiFilter(filters, scopeItemId, loopId);

  const response = await tempoApi()
    .get(`${INSIGHTS_API_BASE}/health/summary`, {
      searchParams: {
        ...(filterString && { filter: filterString }),
      },
      timeout: INSIGHTS_TIMEOUT_MS,
    })
    .json<ItemsHealthMetrics>();

  return response;
};

const getItemHealth = async (
  request: ItemHealthByItemIdsRequest,
): Promise<ItemHealthByItemIdsResponse> => {
  const response = await tempoApi()
    .post(`${INSIGHTS_API_BASE}/health/by-item-ids`, {
      json: request.itemIds,
      timeout: INSIGHTS_TIMEOUT_MS,
    })
    .json<ItemHealthByItemIdsResponse>();

  return response;
};

export const HealthApi = {
  getHealthSummary,
  getItemHealth,
};
